export default "__VITE_ASSET__ClPTY_dG__"